import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * No-op HTTP interceptor used in dev bypass mode.
 * Replaces MsalInterceptor so API calls go through without bearer tokens.
 * The backend must also be configured to allow anonymous access in dev,
 * or you can add a static/fake token here if needed.
 */
@Injectable()
export class DevAuthInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Pass through all requests without adding auth headers
    return next.handle(req);
  }
}
